module.exports = __webpack_public_path__ + "static/media/icono-tienda-virtual.ba1e9d1f.webp";